"use client";

import type { FranchiseJobGroup } from "./types";

import { Button } from "@homeinstead/ui/components/Button";
import { useState } from "react";
import { FranchiseGroup } from "./FranchiseGroup";
import { SearchArea } from "./SearchArea";

/** Number of franchise groups to show initially and to add on each "Load more" click */
const PAGE_SIZE = 10;

interface ResultsViewProps {
  franchiseGroups: FranchiseJobGroup[];
  searchQuery?: string;
}

export function ResultsView({
  franchiseGroups,
  searchQuery,
}: ResultsViewProps) {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const [previousSearchQuery, setPreviousSearchQuery] = useState(searchQuery);

  if (searchQuery !== previousSearchQuery) {
    setPreviousSearchQuery(searchQuery);
    setVisibleCount(PAGE_SIZE);
  }
  const visibleGroups = franchiseGroups.slice(0, visibleCount);
  const hasMore = visibleCount < franchiseGroups.length;

  return (
    <div className="flex flex-col">
      <div className="bg-clear-sky-tints-500">
        <div className="mx-auto flex max-w-screen-hd flex-col gap-8 px-4 py-10 sm:items-center sm:gap-16 sm:px-10 sm:text-center lg:px-[72px] lg:py-20 2xl:px-[152px]">
          <SearchArea
            className="max-w-[756px] sm:text-center"
            defaultQuery={searchQuery}
            heading={
              searchQuery
                ? `Search results for \u201c${searchQuery}\u201d`
                : "Search results"
            }
          />
        </div>
      </div>

      <div className="bg-support-tints-400">
        <div className="mx-auto flex max-w-screen-hd flex-col gap-16 py-10 md:gap-20 md:py-20">
          {visibleGroups.map((group) => (
            <FranchiseGroup group={group} key={group.franchiseNum} />
          ))}

          {hasMore && (
            <div className="flex justify-center">
              <Button
                onClick={() => setVisibleCount((prev) => prev + PAGE_SIZE)}
                variant="outline"
              >
                Load more
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
